import { useCallback } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ContactsContent } from '@/features/contacts/components/ContactsContent';

interface ContactsSearch {
  listId?: string;
}

export const Route = createFileRoute('/_dashboard/contacts')({
  validateSearch: (search: Record<string, unknown>): ContactsSearch => ({
    listId: typeof search.listId === 'string' && search.listId ? search.listId : undefined,
  }),
  component: ContactsPage,
});

function ContactsPage() {
  const { listId } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  // The selected list lives in the URL so it survives reloads and can be linked to.
  const handleListChange = useCallback(
    (nextListId: string | undefined) => {
      void navigate({ search: { listId: nextListId }, replace: true });
    },
    [navigate],
  );

  return <ContactsContent listId={listId} onListChange={handleListChange} />;
}
